import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import {useStateHook} from 'front-onceforall-core/dist/utils/customHooks';

import * as snackbarsActions from '../../../../actions/snackbars';
import subscriptionService from '../../../../services/subscription/SubscriptionService';
import {captureError} from '../../../../utils/log';

import InvoicesView from './InvoicesView';

const size = 10;

function InvoicesContainer() {
  const organisation = useSelector(globalState => globalState.organisation);
  const [state, setState] = useStateHook({
    loading: true,
    invoices: [],
    nextOffset: null
  });
  const dispatch = useDispatch();

  function getInvoices() {
    setState({loading: true});
    subscriptionService.getInvoicesByOrganisation(organisation.organisationId, state.nextOffset, size)
      .then(response => {
        setState(current => ({
          invoices: [...current.invoices, ...response.invoices],
          nextOffset: response.nextOffset,
          loading: false
        }));
      })
      .catch(error => {
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        captureError('Error while loading invoices', error);
        setState({loading: false});
      });
  }

  React.useEffect(getInvoices, []);

  return (
    <InvoicesView
      loading={state.loading}
      invoices={state.invoices}
      onLoadMore={getInvoices}
      showButton={Boolean(state.nextOffset)}
    />
  );
}

export default InvoicesContainer;
